module.exports = __webpack_public_path__ + "static/media/dappnode-logo.db33a17a.png";